"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var messages_1 = __importDefault(require("./messages"));
var validations_1 = __importDefault(require("./validations"));
var EMPTY_ERROR = "";
var validator = function (validation, value) {
    var _a;
    var objectEntries = Object.entries(validation);
    for (var i = 0; i < objectEntries.length; i++) {
        var _b = objectEntries[i], validationKey = _b[0], validationValue = _b[1];
        var typeValidation = validationKey === "type" ? validationValue : validationKey;
        if (typeValidation in validations_1.default &&
            !((_a = validations_1.default[typeValidation]) === null || _a === void 0 ? void 0 : _a.call(validations_1.default, value, validationValue))) {
            return messages_1.default[typeValidation].replace("%1", validationValue);
        }
    }
    return EMPTY_ERROR;
};
exports.default = validator;
//# sourceMappingURL=validator.js.map